import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { TipoCobranca } from '../interfaces/tipo-cobranca';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';
import { TipoCobrancaProjection } from '../interfaces/tipo-cobranca-projection';

@Injectable({
  providedIn: 'root'
})
export class TipoCobrancaService {


  readonly path = '/tipoCobranca';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }


  create(): Observable<TipoCobranca> {
    return this.http.post<TipoCobranca>(`${this.jwtAuthService.apiUrl + this.path}`, null);
  }

  saveOrUpdate(TipoCobranca: TipoCobranca): Observable<TipoCobranca> {
    return this.http.put<TipoCobranca>(`${this.jwtAuthService.apiUrl + this.path}`, TipoCobranca);
  }

  getTipoCobranca(id: number ): Observable<TipoCobranca> {
    return this.http.get<TipoCobranca>(`${this.jwtAuthService.apiUrl + this.path}/?tipoCobranca=${id}`);
  }

  getTipoCobrancaPage(page?: number, size?: number, order = 'NENHUM', direction = 'ASC'): Observable<PageResult<TipoCobranca>> {
    return this.http.get<PageResult<TipoCobranca>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}&order=${order}&direction=${direction}`);
  }
  
  getTipoCobrancaProjectionPage(page?: number, size?: number, order = 'NENHUM', direction = 'ASC'): Observable<PageResult<TipoCobrancaProjection>> {
    return this.http.get<PageResult<TipoCobrancaProjection>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/projection?page=${page}&size=${size}&order=${order}&direction=${direction}`);
  }

  getTipoCobrancaPageSearch(page?: number, size?: number,  search?: string, order = 'NENHUM', direction = 'ASC'): Observable<PageResult<TipoCobranca>> {
    return this.http.get<PageResult<TipoCobranca>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}&search=${search}&order=${order}&direction=${direction}`);
  }
  
  getTipoCobrancaProjectionPageSearch(page?: number, size?: number,  search?: string, order = 'NENHUM', direction = 'ASC'): Observable<PageResult<TipoCobrancaProjection>> {
    return this.http.get<PageResult<TipoCobrancaProjection>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/projection?page=${page}&size=${size}&search=${search}&order=${order}&direction=${direction}`);
  }

  deleteTipoCobranca(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }


}
